import { Dayjs } from "dayjs"
import {
  IWarrantsFilesJob,
  WarrantsFilesJobStatus,
} from "@/models/admin/warrantsFilesJob/warrantsFilesJob.types"
import { sentenceCase } from "@/helpers/stringHelpers"

export class WarrantsFilesJob implements IWarrantsFilesJob {
  constructor(
    public id: number,
    public status: WarrantsFilesJobStatus,
    public errorMessage: string | null,
    public startedAt: Dayjs,
    public endedAt: Dayjs | null,
    public createdAt: Dayjs,
  ) {}

  get statusDisplay(): string {
    return sentenceCase(this.status)
  }
}
